import React from 'react';
import get from 'lodash/get';
import classnames from 'classnames';
import partial from 'lodash/partial';
import {Link} from 'react-router-dom';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import {formatDate} from 'utils/DBUtils';

export default {
  Entrant: props => ({
    className: entry => classnames({
      'winning-entry': entry.winner,
      'forfeited-entry': entry.forfeitDate
    }),
    header: <FormattedMessage id='entriesList.column.header.entrant' />,
    fieldName: 'lastName',
    detailFunc: entry => [entry.firstName, entry.lastName].join(' '),
    canSort: true
  }),

  Email: props => ({
    header: <FormattedMessage id='entriesList.column.header.email' />,
    fieldName: 'email',
    detailFunc: entry => <a href={`mailto:${entry.email}`}>{entry.email}</a>,
    canSort: true
  }),

  EntryDate: props => ({
    header: <FormattedMessage id='entriesList.column.header.entryDate' />,
    fieldName: '_created',
    detailFunc: entry => formatDate(entry._created, props.entriesTableConfig.dateFormat),
    canSort: true
  }),

  WinDate: props => ({
    header: <FormattedMessage id='entriesList.column.header.winDate' />,
    fieldName: 'dateWon',
    detailFunc: entry => entry.dateWon && formatDate(entry.dateWon, props.entriesTableConfig.dateFormat)
  }),

  ForfeitDate: props => ({
    header: <FormattedMessage id='entriesList.column.header.forfeitDate' />,
    fieldName: 'forfeitDate',
    detailFunc: entry => entry.forfeitDate && formatDate(entry.forfeitDate, props.entriesTableConfig.dateFormat)
  })
};



// WEBPACK FOOTER //
// ./public/pages/ListEntries/columns.jsx